import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import _ from 'lodash'
import {
  formatCurrency,
  formatDecimal,
  formatDecimalDynamic,
} from 'utils/masks'

import ResizableDiv from 'component/ResizableDiv'

import Col from 'component/utils/Col'
import Notification from 'component/utils/Notification'

import resize from 'images/h-resize.svg'

const YES = '1'

class Table extends Component {
  state = {
    topMargin: 0,
  }

  static getDerivedStateFromProps(props, state) {
    if (props.topMargin !== state.topMargin) {
      return {
        topMargin: props.topMargin,
      }
    }

    return null
  }

  handleLeft = () => {
    const { columns, rotativeInventoryList } = this.props

    const columnsToRender = columns.filter(
      (column) => column.fixed && column.render
    )

    columnsToRender.map((column, index) => {
      const node = ReactDOM.findDOMNode(this.refs[column.field])

      if (node && index > 0) {
        const lastNode = ReactDOM.findDOMNode(
          this.refs[columnsToRender[index - 1].field]
        )

        if (lastNode) {
          const left = `${
            lastNode.clientWidth + Number(lastNode.style.left.replace('px', ''))
          }px`
          node.style.left = left

          for (let i = 0; i < rotativeInventoryList.length; i++) {
            const tdNode = ReactDOM.findDOMNode(
              this.refs[`${column.field}${i}`]
            )

            if (tdNode) {
              tdNode.style.left = left
            }
          }
        }
      }
    })

    const scrollColumns = columns.filter(
      (column) => !column.fixed && column.render
    )

    scrollColumns.map((column) => {
      const node = ReactDOM.findDOMNode(this.refs[column.field])

      if (node) {
        const left = 'auto'
        node.style.left = left

        for (let i = 0; i < rotativeInventoryList.length; i++) {
          const tdNode = ReactDOM.findDOMNode(this.refs[`${column.field}${i}`])

          if (tdNode) {
            tdNode.style.left = left
          }
        }
      }
    })
  }

  renderNotification = () => {
    const { translate } = this.props

    return (
      <Col xs={12}>
        <Notification
          className='notification-warning'
          message={translate('rotativeInventory.not-found')}
        />
      </Col>
    )
  }

  renderTable = () => {
    if (!_.isEmpty(this.refs)) {
      this.handleLeft()
    }

    return (
      <table className='table-inventory'>
        <thead>
          <tr>{this.renderHeader()}</tr>
        </thead>
        <tbody>{this.renderBody()}</tbody>
      </table>
    )
  }

  renderHeader = () => {
    const { columns, translate } = this.props
    const { topMargin } = this.state

    const style = { top: `${topMargin}px` }

    return columns
      .filter((column) => column.render)
      .map((column, i) => {
        const ref = column.render ? column.field : null

        return (
          <th
            style={style}
            ref={ref}
            className={column.fixed ? 'sticky-column' : 'scroll-column'}
            key={i}
          >
            <ResizableDiv
              className={`cell ${column.className}`}
              width={200}
              axis='x'
              onResizeStop={this.handleLeft}
              handle={
                <div className='resize-handle'>
                  <img src={resize} />
                </div>
              }
            >
              <div className='header'>{translate(column.headerLabel)}</div>
            </ResizableDiv>
          </th>
        )
      })
  }

  renderRows = (column, row) => {
    if (
      column.field === 'accurrancy' ||
      column.field === 'qtDifference' ||
      column.field === 'vlDifference' ||
      column.field === 'integrated'
    ) {
      if (row.c50Counted === undefined) {
        return '-'
      }
    }

    if (
      column.field === 'dsJustificationNotCounted' &&
      row[column.field] === undefined
    ) {
      return '-'
    }

    return column.field === 'c50Counted' && row[column.field] === undefined
      ? '-'
      : this.applyMask(column.type, row[column.field], row.numHouses)
  }

  renderBody = () => {
    const { columns, rotativeInventoryList } = this.props

    this.props.handleResize()

    return rotativeInventoryList.map((row, i) => (
      <tr key={i}>
        {columns
          .filter((column) => column.render)
          .map((column, j) => {
            const ref = column.render ? `${column.field}${i}` : null
            return (
              <td
                key={j}
                ref={ref}
                className={`${
                  column.fixed ? 'sticky-column' : 'scroll-column'
                }`}
              >
                <div className={column.className}>
                  {this.renderRows(column, row)}
                </div>
              </td>
            )
          })}
      </tr>
    ))
  }

  applyMask = (type, value, numHouses) => {
    switch (type) {
      case 'general':
        return this.renderGeneralField(value)

      case 'currency':
        return this.renderCurrencyField(value)

      case 'index':
        return this.renderIndexField(value)

      case 'invert':
        return this.renderInvertField(value)

      case 'decimal':
        return this.renderDecimalField(value)

      case 'decimal-p3':
        return this.renderDecimalDynamicField(value, numHouses)

      default:
        return this.renderGeneralField(value)
    }
  }

  renderGeneralField = (value) => value || '-'

  renderCurrencyField = (value) => {
    const { translate } = this.props

    return (
      <span style={value < 0 ? { color: 'red', fontWeight: 'bold' } : {}}>
        {formatCurrency(value, translate)}
      </span>
    )
  }

  renderIndexField = (value) => {
    const { translate } = this.props

    return value === YES ? translate('true') : translate('false')
  }

  renderInvertField = (value) => {
    const { translate } = this.props

    return value === 1 ? translate('false') : translate('true')
  }

  renderDecimalField = (value) => {
    const { translate } = this.props

    return (
      <span style={value < 0 ? { color: 'red', fontWeight: 'bold' } : {}}>
        {formatDecimal(value, translate)}
      </span>
    )
  }

  renderDecimalDynamicField = (value, numHouses) => {
    const { translate } = this.props

    return (
      <span style={value < 0 ? { color: 'red', fontWeight: 'bold' } : {}}>
        {formatDecimalDynamic(value, numHouses, translate)}
      </span>
    )
  }

  render() {
    const { rotativeInventoryList } = this.props

    return (
      <>
        {_.isEmpty(rotativeInventoryList)
          ? this.renderNotification()
          : this.renderTable()}
      </>
    )
  }
}

Table.propTypes = {
  translate: PropTypes.func.isRequired,
  rotativeInventoryList: PropTypes.array.isRequired,
  includeLot: PropTypes.bool.isRequired,
  includeProvider: PropTypes.bool.isRequired,
  columns: PropTypes.array.isRequired,
  filters: PropTypes.object,
  handleResize: PropTypes.funcion,
  topMargin: PropTypes.object,
}

export default Table
